import React, { useRef, useEffect, useState } from "react";
import api from "../../services/api";

import errors, { IAliancaErrors } from "../../Utils/ExtractErrors";

import { Form, Modal, Button, Grid, Image, Loader, Dimmer, Input, DropdownProps, TextAreaProps, Message } from "semantic-ui-react";
import { toast } from "react-toastify";

import ModalApp from "../../components/ModalApp";
import ImageZoom from "../../components/ImageZoom";
import ModalYesNo from "../../components/ModalYesNo";

import ResellersRepository, { IResellerListModel } from "../../Repositories/ResellersRepository";
import TrocaRepository from "../../Repositories/ExchangeRepository";
import ImagemRepository from "../../Repositories/ImagesRepository";
import CategoriaRepository from "../../Repositories/CategoriaRepository";
import ProdutoRepository, { IProdutoListModel } from "../../Repositories/ProdutoRepository";

import { eBanho, eStatusTroca, eStepTroca, ICategoria, IImagem, ITroca } from "../../interfaces";
import { GetUser } from "../../services/auth";
import CustomLoader from "../../components/CustomLoader";

interface State extends Omit<ITroca, "banho"> {
    banho: string | number;
    images: IImagem[];
    cidade: string;
    uf: string;
    devedor: number;
    apiErrors: IAliancaErrors;
}

interface Props {
    trocaId: string;
    onSuccess: () => void;
}

const initialState: State = {
    id: "",
    data: "",
    representanteId: "",
    revendedorId: "",
    categoriaId: "",
    produtoId: "",
    banho: "",
    status: eStatusTroca.Pendente,
    step: eStepTroca.EnviadoParaEmpresa,
    descricao: "",
    dataTroca: "",
    images: [],
    cidade: "",
    uf: "",
    devedor: 0,
    apiErrors: { errors: [] }
}

const EditarTroca: React.FC<Props> = (props) => {
    const [open, setOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<State>(initialState);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [preview, setPreview] = useState<string[]>([]);
    const [revendedores, setRevendedores] = useState<IResellerListModel[]>([]);
    const [categorias, setCategorias] = useState<ICategoria[]>([]);
    const [produtos, setProdutos] = useState<IProdutoListModel[]>([]);

    const fileInputRef = useRef<HTMLInputElement>(null);

    const { role } = GetUser();

    const banhos = [
        { key: 0, value: eBanho.Ouro, text: "Ouro" },
        { key: 1, value: eBanho.Prata, text: "Prata" },
        { key: 2, value: eBanho.Rodio, text: "Ródio" },
    ];

    const load = async () => {
        setLoading(true);

        try {
            const [exchange, images, resellers, categories, products] = await Promise.all([
                TrocaRepository.GetById(props.trocaId),
                ImagemRepository.GetByReferenceId(props.trocaId),
                ResellersRepository.List({ filter: "STATUS <= 1" }),
                CategoriaRepository.List({
                    filter: "STATUS == 1"
                }),
                ProdutoRepository.List({
                    filter: "STATUS == 1"
                })
            ]);
            setState(state => ({
                ...state,
                ...exchange,
                images,
                cidade: (resellers.list.find(reseller => reseller.id === exchange.revendedorId) as IResellerListModel || { cidade: "" }).cidade,
                uf: (resellers.list.find(reseller => reseller.id === exchange.revendedorId) as IResellerListModel || { uf: "" }).uf,
                devedor: (resellers.list.find(reseller => reseller.id === exchange.revendedorId) as IResellerListModel || { devedor: "" }).devedor
            }));
            setRevendedores(resellers.list as IResellerListModel[]);
            setCategorias(categories.list as ICategoria[]);
            setProdutos(products.list as IProdutoListModel[]);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    }

    const onButtonClick = () => {
        if (fileInputRef && fileInputRef.current) {
            fileInputRef.current.click();
        }
    }

    useEffect(() => {
        if (selectedFiles.length > 0) {
            let images: string[] = [];

            for (const file of selectedFiles) {
                images.push(URL.createObjectURL(file));
            }

            setPreview(preview => preview.concat(images));

            return () => {
                for (const image of images) { URL.revokeObjectURL(image) }
                setPreview([]);
            }
        }
    }, [selectedFiles])

    const onSelectFile = (e: any) => {
        if (!e.target.files || e.target.files.length === 0) {
            setSelectedFiles([])
            return

        }

        let files: File[] = [];
        files = files.concat(selectedFiles);

        for (const file of e.target.files) {
            files.push(file);
        }

        setSelectedFiles(files);
    }

    const onRemovePreview = (imageUrl: string, index: number) => {
        const images = preview.filter(x => x !== imageUrl);

        selectedFiles.splice(index, 1);

        URL.revokeObjectURL(imageUrl);
        setPreview(images);
    }

    const onRemove = async (id: string) => {
        await ImagemRepository.DeleteById(id);
        load();
    }

    const handleSubmitForm = async () => {
        if ((role === "GerenteS" && selectedFiles.length >= 1) || role === "Admin" || role === "Operador") {
            try {
                setLoading(true);

                const data = new FormData();

                data.append("categoriaId", state.categoriaId);
                data.append("produtoId", state.produtoId);
                data.append("banho", state.banho as string);
                data.append("descricao", state.descricao);

                if (role === "GerenteS" && state.step === eStepTroca.EnviadoParaGerenteSetor) {
                    data.append("step", eStepTroca.Finalizado.toString());
                } else {
                    data.append("step", state.step.toString());
                }

                data.append("status", state.status.toString());

                for (const file of selectedFiles) {
                    data.append("files", file);
                }

                const response = await TrocaRepository.Update(props.trocaId, data);

                setSelectedFiles([]);
                setPreview([]);

                toast(`🎉 ${response.message}`, { position: "top-center", type: "success" });
                setOpen(false);
                props.onSuccess();

            } catch (err) {
                if (err.response.status === 401) {
                    window.location.href = "/";
                }

                setState({ ...state, apiErrors: err.response.data });

                const error = errors.getApiErrors(state.apiErrors);

                if (error !== undefined)
                    toast(error, { position: "top-center", type: "error" });
            }
            setLoading(false);
        } else {
            toast("❌ É necessário inserir no mínimo 1 foto.", { position: "top-center", type: "error" });
        }
    }

    const handleChangeStep = (step: eStepTroca) => {
        setState(state => ({ ...state, step }));
    }

    const handleChangeStatus = (status: eStatusTroca) => {
        setState(state => ({ ...state, status }));
    }

    const handleOpen = () => {
        load();
        setOpen(true);
    }

    const handleClose = () => {
        setState(initialState);
        setOpen(false);
        setSelectedFiles([]);
        setPreview([]);
    }

    const onDropdownChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    const onTextAreaChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: TextAreaProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    const editarContent = (
        <Modal.Content scrolling>
            {loading &&
                <CustomLoader />}
            {!loading &&
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field width={10} required>
                            <label>Revendedor</label>
                            <Form.Dropdown
                                fluid
                                selection
                                scrolling
                                open={false}
                                name="revendedorId"
                                noResultsMessage="Nenhum registro encontrado."
                                placeholder="Selecione"
                                value={state.revendedorId}
                                options={revendedores.map(revendedor => { return { key: revendedor.id, value: revendedor.id, text: revendedor.nome } })}
                            />
                        </Form.Field>
                        <Form.Field width={4}>
                            <label>Cidade</label>
                            <Input
                                readOnly
                                placeholder="Cidade"
                                value={state.cidade}
                            />
                        </Form.Field>
                        <Form.Field width={2}>
                            <label>Estado</label>
                            <Input
                                readOnly
                                placeholder="Estado"
                                value={state.uf}
                            />
                        </Form.Field>
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field width={5} required>
                            <label>Categoria</label>
                            <Form.Dropdown
                                fluid
                                selection
                                scrolling
                                onChange={onDropdownChange}
                                disabled={role !== "Admin"}
                                name="categoriaId"
                                noResultsMessage="Nenhum registro encontrado."
                                placeholder="Selecione"
                                value={state.categoriaId}
                                options={categorias.map(categoria => { return { key: categoria.id, value: categoria.id, text: categoria.nome } })}
                            />
                        </Form.Field>
                        <Form.Field
                            width={7}
                            required
                        >
                            <label>Produto</label>
                            <Form.Dropdown
                                fluid
                                selection
                                scrolling
                                onChange={onDropdownChange}
                                disabled={role !== "Admin"}
                                name="produtoId"
                                noResultsMessage="Nenhum registro encontrado."
                                placeholder="Selecione"
                                value={state.produtoId}
                                options={
                                    produtos
                                        .filter(produto => produto.categoria === categorias.find(categoria => categoria.id === state.categoriaId)?.nome)
                                        .map(produto => { return { key: produto.id, value: produto.id, text: produto.nome } })
                                }
                            />
                        </Form.Field>
                        <Form.Field
                            width={4}
                            required
                        >
                            <label>Banho</label>
                            <Form.Dropdown
                                fluid
                                selection
                                onChange={onDropdownChange}
                                disabled={role !== "Admin"}
                                name="banho"
                                noResultsMessage="Nenhum registro encontrado."
                                placeholder="Selecione"
                                value={state.banho}
                                options={banhos}
                            />
                        </Form.Field>
                    </Form.Group>
                    <Form.Field required>
                        <label>Descrição</label>
                        <Form.TextArea
                            readOnly={role !== "Admin"}
                            placeholder="Descrição do defeito"
                            onChange={onTextAreaChange}
                            name="descricao"
                            value={state.descricao}
                        />
                    </Form.Field>
                    {state.devedor === 1 &&
                        <Form.Field>
                            <Message
                                size="huge"
                                negative
                                icon="dont"
                                header="ATENÇÃO"
                                content="REVENDEDOR POSSUI DÉBITOS, NÃO EFETUAR A TROCA."
                            />
                        </Form.Field>
                    }
                    {(role === "GerenteS" && state.step === eStepTroca.EnviadoParaGerenteSetor) &&
                        <Form.Field>
                            <p>
                                <strong>
                                    FOTOS NECESSÁRIAS:<br /> FOTO DA REPRESENTANTE RECEBENDO A TROCA.
                                </strong>
                            </p>
                            <Button
                                content="Selecionar fotos"
                                icon="images"
                                fluid
                                onClick={onButtonClick}
                                color="black"
                            />
                            <input
                                ref={fileInputRef}
                                type="file"
                                hidden
                                multiple
                                accept="image/*"
                                onChange={onSelectFile}
                            />
                        </Form.Field>
                    }
                    {(role === "Operador" || role === "Admin") &&
                        <Form.Field>
                            <Button
                                content="Selecionar fotos"
                                icon="images"
                                fluid
                                onClick={onButtonClick}
                                color="black"
                            />
                            <input
                                ref={fileInputRef}
                                type="file"
                                hidden
                                multiple
                                accept="image/*"
                                onChange={onSelectFile}
                            />
                        </Form.Field>
                    }
                    {(role === "Admin" || role === "Operador") &&
                        <Grid>
                            <Grid.Row>
                                <Grid.Column>
                                    <Button.Group fluid>
                                        <Button
                                            icon="send"
                                            content="Enviado"
                                            color={state.step === eStepTroca.EnviadoParaEmpresa ? `teal` : undefined}
                                            onClick={() => handleChangeStep(eStepTroca.EnviadoParaEmpresa)}
                                        />
                                        <Button.Or text="OU" />
                                        <Button
                                            icon="thumbs down"
                                            content="Não Veio"
                                            color={state.step === eStepTroca.NaoVeioNaPasta ? `black` : undefined}
                                            onClick={() => handleChangeStep(eStepTroca.NaoVeioNaPasta)}
                                        />
                                        <Button.Or text="OU" />
                                        <Button
                                            icon="industry"
                                            content="Empresa"
                                            color={state.step === eStepTroca.RecebidoPelaEmpresa ? `purple` : undefined}
                                            onClick={() => handleChangeStep(eStepTroca.RecebidoPelaEmpresa)}
                                        />
                                        <Button.Or text="OU" />
                                        <Button
                                            icon="truck"
                                            content="G.S."
                                            color={state.step === eStepTroca.EnviadoParaGerenteSetor ? `pink` : undefined}
                                            onClick={() => handleChangeStep(eStepTroca.EnviadoParaGerenteSetor)}
                                        />
                                        <Button.Or text="OU" />
                                        <Button
                                            icon="flag checkered"
                                            content="Finalizado"
                                            color={state.step === eStepTroca.Finalizado ? `green` : undefined}
                                            onClick={() => handleChangeStep(eStepTroca.Finalizado)}
                                        />
                                        <Button.Or text="OU" />
                                        <Button
                                            icon="user times"
                                            content="Devedor"
                                            color={state.step === eStepTroca.Devedor ? `red` : undefined}
                                            onClick={() => handleChangeStep(eStepTroca.Devedor)}
                                        />
                                    </Button.Group>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column>
                                    <Button.Group fluid>
                                        <Button
                                            icon="thumbs down"
                                            content="Não Veio"
                                            color={state.status === eStatusTroca.NaoVeioNaPasta ? `black` : undefined}
                                            onClick={() => handleChangeStatus(eStatusTroca.NaoVeioNaPasta)}
                                        />
                                        <Button.Or text="OU" />
                                        <Button
                                            icon="clock"
                                            content="Pendente"
                                            color={state.status === eStatusTroca.Pendente ? `blue` : undefined}
                                            onClick={() => handleChangeStatus(eStatusTroca.Pendente)}
                                        />
                                        <Button.Or text="OU" />
                                        <Button
                                            icon="times circle"
                                            content="Troca não efetuada"
                                            color={state.status === eStatusTroca.NaoEfetuada ? `red` : undefined}
                                            onClick={() => handleChangeStatus(eStatusTroca.NaoEfetuada)}
                                        />
                                        <Button.Or text="OU" />
                                        <Button
                                            icon="check circle"
                                            content="Troca efetuada"
                                            color={state.status === eStatusTroca.Efetuada ? `green` : undefined}
                                            onClick={() => handleChangeStatus(eStatusTroca.Efetuada)}
                                        />
                                        <Button.Or text="OU" />
                                        <Button
                                            icon="user times"
                                            content="Devedor"
                                            color={state.status === eStatusTroca.Devedor ? `red` : undefined}
                                            onClick={() => handleChangeStatus(eStatusTroca.Devedor)}
                                        />
                                    </Button.Group>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    }
                    <Grid columns={4} doubling>
                        {state.images.length > 0 &&
                            state.images.map((x, index) =>
                                <Grid.Column key={`image-${index}`}>
                                    <Image
                                        fluid
                                        label={<ImageZoom imagePath={`${api.defaults.baseURL}/images/${x.arquivo}`} />}
                                        src={`${api.defaults.baseURL}/images/${x.arquivo}`}
                                    />
                                    <ModalYesNo
                                        trigger={<Button icon="trash" color="red" attached="bottom" disabled={role !== "Admin"} />}
                                        header="Apagar"
                                        content="Deseja realmente apagar esta foto?"
                                        onSuccess={() => onRemove(x.id || "")}
                                    />
                                </Grid.Column>
                            )}
                        {preview.length > 0 &&
                            preview.map((x, index) =>
                                <Grid.Column key={`image-${index}`}>
                                    <Image
                                        fluid
                                        label={<ImageZoom imagePath={x} />}
                                        src={x}
                                    />
                                    <ModalYesNo
                                        trigger={<Button icon="trash" color="red" attached="bottom" />}
                                        header="Apagar"
                                        content="Deseja realmente apagar esta foto?"
                                        onSuccess={() => onRemovePreview(x, index)}
                                    />
                                </Grid.Column>
                            )}
                    </Grid>
                </Form>}
        </Modal.Content>
    );

    return (
        <ModalApp
            open={open}
            handleOpen={handleOpen}
            handleClose={handleClose}
            title="Editar"
            content={editarContent}
            trigger={{
                icon: "pencil",
                color: "pink",
            }}
            onSuccess={
                ((role === "GerenteS" && state.step === eStepTroca.EnviadoParaGerenteSetor) ||
                    (role === "Admin" || role === "Operador"))
                    ? { content: "Salvar", func: handleSubmitForm }
                    : undefined
            }
        />
    );
};

export default EditarTroca;
